export default __webpack_public_path__ + "static/sourcenextLogo-fbad70604975ed4745b62e0859893291.png";